<div class="footer" role="contentinfo">
  <ul aria-label="Footer navigation link list">
    <li><a routerLink="/page/help-lux-audience-award">Help</a></li>
    <li><a routerLink="/page/terms-and-conditions-lux-audience-award">Terms & Conditions</a></li>
    <li><a routerLink="/page/privacy-policy-lux-audience-award">Data Protection Notice</a></li>
    <li><a routerLink="/page/cookies-policy-lux-audience-award">Cookies Policy</a></li>
    <li><a routerLink="/page/contact-us-lux-audience-award">Contact Us</a></li>
  </ul>
</div>
